<template>
  <footer class="footer">
    <div class="footer-inner">
      <!-- 메인 컨텐츠 -->
      <div class="footer-content">
        <!-- 왼쪽: 브랜드 & 회사정보 -->
        <div class="footer-left">
          <img src="@/assets/logo.png" alt="분양쟁이" class="footer-logo" />
          
          <div class="company-details">
            <p>대표: 심응선 <span class="bar">|</span> 사업자등록번호: 227-31-01670</p>
            <p>통신판매업: 제 2024-충북청주-2550</p>
            <p>충청북도 청주시 서원구 충대로1, S1-3동 2층 201호 충북대학교 충북Pro메이커센터</p>
          </div>

          <div class="footer-links">
            <router-link to="/terms" class="footer-link">이용약관</router-link>
            <span class="bar">|</span>
            <router-link to="/privacy" class="footer-link privacy">개인정보처리방침</router-link>
          </div>
        </div>

        <!-- 오른쪽: 고객센터 -->
        <div class="footer-right">
          <span class="contact-label">고객센터</span>
          <a href="tel:1533-9012" class="contact-number">1533-9012</a>
          <p class="contact-hours">평일 09:00 - 18:00 (주말/공휴일 휴무)</p>
          <a href="mailto:eslabsofficial@gmail.com" class="contact-email">
            eslabsofficial@gmail.com
          </a>
        </div>
      </div>

      <!-- 하단 -->
      <div class="footer-bottom">
        <p class="notice">
          이에스랩스 코퍼레이션은 분양 구인·구직 정보를 연결하는 플랫폼으로서, 이용자 문의에 신속하고 성실하게 답변드리고 있습니다.
        </p>
        <p class="copyright">© ESLabs Corporation. All rights reserved.</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>

<style scoped>
.footer {
  background: #0a0a0a;
  margin-top: 100px;
}

.footer-inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 60px 32px 48px;
}

/* 메인 컨텐츠 */
.footer-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-bottom: 48px;
  border-bottom: 1px solid #1a1a1a;
}

/* 왼쪽 */
.footer-left {
  display: flex;
  flex-direction: column;
  gap: 28px;
}

.footer-logo {
  width: 160px;
  height: auto;
  object-fit: contain;
}

.company-details p {
  font-size: 14px;
  color: #808080;
  line-height: 1.9;
}

.bar {
  color: #404040;
  margin: 0 8px;
}

.footer-links {
  display: flex;
  align-items: center;
}

.footer-link {
  font-size: 14px;
  color: #909090;
  transition: color 0.2s;
}

.footer-link:hover {
  color: #fff;
}

.footer-link.privacy {
  font-weight: 600;
  color: #d0d0d0;
}

/* 오른쪽 - 고객센터 */
.footer-right {
  text-align: right;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.contact-label {
  font-size: 14px;
  color: #707070;
  margin-bottom: 12px;
}

.contact-number {
  font-size: 42px;
  font-weight: 800;
  color: #ffffff;
  letter-spacing: -1.5px;
  line-height: 1;
  margin-bottom: 16px;
  transition: color 0.2s;
}

.contact-number:hover {
  color: #3182f6;
}

.contact-hours {
  font-size: 14px;
  color: #606060;
  margin-bottom: 20px;
}

.contact-email {
  font-size: 15px;
  color: #909090;
  transition: color 0.2s;
}

.contact-email:hover {
  color: #fff;
}

/* 하단 */
.footer-bottom {
  padding-top: 32px;
  text-align: center;
}

.notice {
  font-size: 13px;
  color: #505050;
  line-height: 1.7;
  margin-bottom: 16px;
}

.copyright {
  font-size: 13px;
  color: #404040;
  letter-spacing: 0.3px;
}

/* 태블릿 */
@media (max-width: 900px) {
  .footer-content {
    flex-direction: column;
    gap: 48px;
  }

  .footer-right {
    text-align: left;
    align-items: flex-start;
  }
}

/* 모바일 */
@media (max-width: 600px) {
  .footer {
    margin-top: 72px;
  }

  .footer-inner {
    padding: 48px 20px 36px;
  }

  .footer-content {
    gap: 40px;
    padding-bottom: 36px;
  }

  .footer-left {
    gap: 24px;
  }

  .footer-logo {
    width: 130px;
  }

  .company-details p {
    font-size: 13px;
    line-height: 1.8;
  }

  .bar {
    display: none;
  }

  .company-details p span:first-child::after {
    content: '\A';
    white-space: pre;
  }

  .footer-link {
    font-size: 13px;
  }

  .contact-label {
    font-size: 13px;
    margin-bottom: 8px;
  }

  .contact-number {
    font-size: 32px;
    margin-bottom: 12px;
  }

  .contact-hours {
    font-size: 13px;
    margin-bottom: 16px;
  }

  .contact-email {
    font-size: 14px;
  }

  .footer-bottom {
    padding-top: 28px;
    text-align: left;
  }

  .notice {
    font-size: 12px;
    margin-bottom: 12px;
  }

  .copyright {
    font-size: 12px;
  }
}
</style>